import ModalImage from "./assets/Nodemodules/react-modal-image";

import axios from 'axios'
import Base from './Config'
import React, { Component,PureComponent } from 'react'
import NavigationItems from './Components/NavigationItems'
import PageHeader from './Components/PageHeader'
import Footer from './Components/Footer'
import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { 
    LoopCircleLoading,
    WaveLoading,
} from 'react-loadingg';
// import Viewimage from './assets/img/brand/viewimage.png'
// import ModalImage from "react-modal-image";

class ItemsNotification extends Component {

    edit=()=>{
        // console.log('Edit ',this.props.data);
        this.props.Edit(this.props.data)
    }

    delete=()=>{
        // console.log('delete ',this.props.data);
        this.props.Delete(this.props.data)
    }

    render() {
        const data = this.props.data
        const date = new Date(data.date);
        
        // if(data.image){
        //     console.log('props ',data.image.image);
        // }
        

        return (
            <tr>
                <td>
                <label className="label h4 opacity-8">{data.sub_title}</label>
                    <br/>
                    <textarea readOnly className="form form-control bg-amber-100" style={{maxWidth: 400}}  value={data.notification} ></textarea> 
                    <br/>
                    <label className="label h5 opacity-5">Date : {date.toDateString()}</label>
                    </td>
                {/* <td>
                    <textarea readOnly className="form form-control" style={{maxWidth: 400}}  value={data.notification} ></textarea> 
                </td> */}

                <td>
                {data.image&&
                <>
                    <ModalImage

                        style={{
                            height:"100px",
                        }}
                        // small={Viewimage}
                        small={data.image.image}
                        large={data.image.image}
                        // alt={data.user_det.user.username+"-"+data.service.name}
                        hideDownload={true}
                        showRotate={true}
                    />
                {/* <img height={50} src={data.image.image}/> */}
                
                </>
                }
                </td>

                {/* <th scope="row">{date.toDateString()}</th> */}
                

                {/* <td>
                <button className="btn-sm btn-outline-primary" onClick={this.edit}>
                <i className="fas fa-edit " ></i>
                </button>
                <span>&nbsp;</span>
                <button className="btn-sm btn-outline-danger" onClick={this.delete}>
                <i className="fas fa-trash"></i>
                </button>
                </td> */}
            </tr>
        );
    }
}


class ListItems extends PureComponent {
    constructor(){
        super()
        this.state={
            default:false
        }
    }
    clicked=(e,id)=>{
        // console.log('item id',this.props.users.id);
        // console.log('checked',e.target.checked);
        if(e.target.checked){
            // console.log(this.props.users.id,' add to array');
            this.props.addToArray(this.props.users.id)
        }
        else{
            // console.log(this.props.users.id,' remove from array');
            this.props.removeFromArray(this.props.users.id)

        }
    }
    

    render() {
        // let check = this.props.users
        // console.log('check ',check);
        let data = this.props.users
        // console.log('data ',data);
        return (
            <li className="list-group-item">
                <div className="custom-control custom-checkbox mr-sm-2">
                    <input checked={data.checked}  onChange={this.clicked} type="checkbox" className="custom-control-input" id={data.id} />
                    <label className="custom-control-label" htmlFor={data.id}>{data.user_type==="T"?"Tenant : ":"Outsider : "}:{data.username}</label>
                </div>
            </li>
        )
    }
}


export default class componentName extends Component {
    constructor(){
        super()
        this.state={
            data:[],
            next:null,
            prev:null,
            loading:true,

            message:"",
            heading:"",
            image:"",


            fortenant:false,
            foroutsider:false,
            individual:false,
            individualList:[],

            loader:false,

            search:"",
            filteredData:[],

            notificationData:[],

        }
    }
    
    loading=(args)=>{
        this.setState({
            loading:args
        })
    }

    componentDidMount(){
        this.fetchAllUsers()
        this.fetchNotifications()
    }

    fetchNotifications(){
        this.loading(true)
        // console.log('read all data');
        // return false
        axios.get(
            Base.url + 'Notifications',
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        ).then(response => {
            // console.log('Response all :', response);
            // console.log('Response all :', response.data);
            
                

            this.setState({
                notificationData: response.data.results,
                next: response.data.next,
                prev: response.data.previous,
                filter:false,
                loading:false
            })
        }).catch(error => {
            console.log('Error loading quotation count: ', error);
            NotificationManager.error('Error : ', error, 3000);
        })
    }

    fetchAllUsers(){
        this.loading(true)
        // console.log('read all data');
        // return false
        axios.get(
            Base.url + 'UserAdditional',
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                    
                }
            }
        ).then(response => {
            // console.log('Response all :', response);
            // console.log('Response all :', response.data);
            let modifiedData = []

            response.data.map((item)=>
                modifiedData.push({
                    id:item.id,
                    username:item.user.username,
                    user_type:item.user_type,
                    checked:false
                })
            )
                
            // console.log('modified data ',modifiedData);

            this.setState({
                data: modifiedData,
                // next: response.data.next,
                // prev: response.data.previous,
                filter:false,
                loading:false
            })
        }).catch(error => {
            console.log('Error loading quotation count: ', error);
            NotificationManager.error('Error : ', error, 3000);
        })
    }
    
    next=()=>{
        this.loading(true)
        axios.get(this.state.next.replace(/^http:\/\//i, 'https://'),{ headers: { 'Authorization': 'Token '+localStorage.getItem('Token'),} }
        ).then(response =>{
            // console.log('res ',response)

            this.setState({
            notificationData:response.data.results,
            next:response.data.next,
            prev:response.data.previous,
            loading:false,
            })
        })
        .catch(error =>{NotificationManager.error('Error : ', error, 3000);
            this.loading(false)

        })
    }
    
    prev=()=>{
        this.loading(true)
    axios.get(
        this.state.prev.replace(/^http:\/\//i, 'https://'),
        { 
            headers: { 
                'Authorization': 'Token '+localStorage.getItem('Token'),
            } 
        }
    ).then(response =>{
        this.setState({
        notificationData:response.data.results,
        next:response.data.next,
        prev:response.data.previous,
        loading:false,
        })
    })
    .catch(error =>{

        NotificationManager.error('Error : ', error, 3000);
        this.loading(false)

    })
    }



    onChange=(e)=>{
        let search = e.target.value
        // console.log('Search ',search);
        // console.log('target ',[e.target.name]);
        
        this.setState ({
            [e.target.name]:e.target.value
        })
    }

    onChangeSearch=(e)=>{
        let search = e.target.value
        // console.log('Search ',search);
        // console.log('target ',[e.target.name]);
        
        this.setState ({
            [e.target.name]:e.target.value
        },()=>{
            const newData = this.state.data.filter(item => {      
                const itemData = `${item.username.toUpperCase()}`;
                const textData = search.toUpperCase();
                return itemData.indexOf(textData) > -1;    
            });
            // console.log("newData :",newData);
            this.setState({ filteredData: newData });  
        })
    }

    changePrevState=(id)=>{
        let newData = []
        let newFiteredData = []
        
        this.state.data.map((item)=>{
            if(item.id ==id){
                // console.log('item ',item);
                
                newData.push({
                    id:item.id,
                    username:item.username,
                    user_type:item.user_type,
                    checked:!item.checked
                })
            }
            else{
                newData.push({
                    id:item.id,
                    username:item.username,
                    user_type:item.user_type,
                    checked:item.checked
                })
            }
        })

        this.state.filteredData.map((item)=>{
            if(item.id ==id){
                // console.log('item ',item);
                
                newFiteredData.push({
                    id:item.id,
                    username:item.username,
                    user_type:item.user_type,
                    checked:!item.checked
                })
            }
            else{
                newFiteredData.push({
                    id:item.id,
                    username:item.username,
                    user_type:item.user_type,
                    checked:item.checked
                })
            }
        })

        this.setState({
            data :newData,
            filteredData:newFiteredData
        })
    }

    add=(id)=>{
        this.changePrevState(id)

        this.setState({
            individualList: [ ...this.state.individualList, id],
        }, () => {
            // console.log(this.state.individualList);
        });
    }
    remove=(id)=>{
        this.changePrevState(id)

        let remove = this.state.individualList.indexOf(id);
        this.setState({
            individualList: this.state.individualList.filter((_, i) => i !== remove)
        },
            () => {
            // console.log('fruits', this.state.individualList);
        }
        );
    }


    clearData=()=>{
        let newdata=[]
        this.state.data.map((item)=>{
            newdata.push({
                id:item.id,
                username:item.username,
                user_type:item.user_type,
                checked:false
            })
         })
         
        // this.state.filteredData.map((item)=>{
        //     newdata.push({
        //         id:item.id,
        //         username:item.username,
        //         user_type:item.user_type,
        //         checked:false
        //     })
        //  })
        this.setState({
            filteredData:newdata,
            data : newdata,
            fortenant:false,
            foroutsider:false,
            individual:false,
            loader:false,
            message:"",
            heading:"",
            image:"",
        })
        this.refs.image.value="" // clear file field

        
        // this.fetchAllUsers()
    }

    sendNotification=()=>{

        // this.state.fortenant
        // this.state.foroutsider
        // this.state.individual

        

        // this.setState({loader:true})

        // console.log('worked ',this.state);

        let fortenant,foroutsider
        if(this.state.fortenant == true){
            fortenant = 1
         }
         else{
            fortenant = 0
         }
 
         if(this.state.foroutsider == true){
            foroutsider = 1
         }
         else{
            foroutsider = 0
         }
            
        var bodyFormData = new FormData();

        if(this.state.individual || this.state.foroutsider || this.state.fortenant){
            // console.log('true');
            // console.log('individual ',this.state.individual);
            // console.log('foroutsider ',foroutsider);
            // console.log('fortenant ',fortenant);
            console.log('list ',this.state.individualList);
            // console.log('list ',this.state.individualList[0]);
            
            
        }else{
            // console.log('false');
            // console.log('individual ',this.state.individual);
            // console.log('foroutsider ',this.state.foroutsider);
            // console.log('fortenant ',this.state.fortenant);
            
            NotificationManager.error( "Please chose recipient ",'Notification Not send : ', 10000)
            return false
        }
        

        if(this.state.individual){
            // console.log('sening for individual');
            bodyFormData.set('for_tenants', 0);
            bodyFormData.set('for_outsiders', 0);
            // bodyFormData.set('user_list',"[67,67]");
            bodyFormData.set('user_list',JSON.stringify(this.state.individualList));
        }
        else{
            // console.log('sening for notindividaual');
            bodyFormData.set('for_tenants', fortenant);
            bodyFormData.set('for_outsiders', foroutsider);
        }
        
        bodyFormData.set('image', this.state.image);
        bodyFormData.set('message', this.state.message);
        bodyFormData.set('title', this.state.heading);
        // return false
        axios.post(
            Base.url + 'Notifications/',
            bodyFormData,
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        )
        .then(response =>{
            // console.log('response : ',response);
                if(response.data.Status){
                    console.log(response.data.Message)
                    NotificationManager.success( response.data.Message,'Success : ',10000)
                    this.clearData()
                    // alert(response.data.Message)
                }else{
                    // console.log(response.data.Message);
                    console.log(response.data.Message)

                    this.setState({loader:false})
                    NotificationManager.error('Error : ', response.data.Error, 10000)
                    // this.clearData()

                    // alert(response.data.Message+" : "+response.data.Error)
                }
        })
        .catch(error=>{
            this.setState({loader:false})
            NotificationManager.error('Error : ', "Notification not send", 10000)

            console.log(error);
        })
    }



    render() {
        return (

            
            <div>
            {/* <NotificationContainer/> */}

               <NavigationItems />
                {/* Main content */}
                <div className="main-content">
                    <PageHeader pageName="Notification"/>

                    <div className="header bg-gradient-primary pb-8 pt-5 pt-md-8">
                        <div className="container-fluid">
                            <div className="header-body">
                                {/* Card stats */}
                                <div className="row">
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Page content */}
                    <div className="container-fluid mt--7">
                        <div className="row">
                            
                             <div className="col-xl-8">
                                <div className="card shadow">
                                    <div className="card-header bg-transparent">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <h2 className="mb-0" />
                                                
                                                <h2>Send Notification</h2>
                                                
                                            </div>
                                        </div>

                                        <form role="form">
                                            <div className="form-group">
                                                <div className="input-group input-group-alternative mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text">
                                                        </span>
                                                    </div>
                                                    <input name="heading" value={this.state.heading} onChange={this.onChange} className="form form-control" placeholder="Heading" type="text" />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div className="input-group input-group-alternative mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text">
                                                        </span>
                                                    </div>
                                                    <textarea name="message" value={this.state.message} onChange={this.onChange} className="form form-control" placeholder="Type Message"  />
                                                </div>
                                            </div>
                                            Choose a image (optional)
                                            <div className="form-group">
                                                <div className="input-group input-group-alternative mb-3">
                                                    <div className="input-group-prepend">
                                                        
                                                        <span className="input-group-text">
                                                            
                                                            <input 
                                                            className="form-control" type="file"  ref='image'  
                                                            onChange={(event) => {this.setState({image: event.target.files[0]})}  }  
                                                            />
                                                            <i  /></span>
                                                    </div>
                                                    {/* <input class="form-control" placeholder="bg.color" type="email"> */}
                                                </div>
                                            </div>
                                            {/* <input type="checkbox" checked={this.state.fortenant} onChange={(event) => this.setState({fortenant: !this.state.fortenant},()=>console.log('state1 changed : ',this.state.fortenant) )} /> Tenant<br />
                                            <input type="checkbox" checked={this.state.foroutsider} onChange={(event) => this.setState({foroutsider: !this.state.foroutsider},()=>console.log('state2 changed : ',this.state.foroutsider) )} /> Outsider<br /> */}
                                            Please select recepient :
                                            <div style={{display:"flex",flexDirection:"row"}}>
                                                <span onClick={(event) => this.setState({fortenant: !this.state.fortenant,individual: false} )} style={{ cursor:"pointer", boxShadow: '0px 1px 2px 0px grey', padding: 10, display: 'flex', height: '100%', flex: 1, justifyContent: 'center', borderBottomLeftRadius: 10, borderTopLeftRadius: 10,backgroundColor:this.state.fortenant?'#6072E4':'white',color:this.state.fortenant?'white':'black' }} >Tenants</span>
                                                <span onClick={(event) => this.setState({foroutsider: !this.state.foroutsider,individual: false} )}  style={{ cursor:"pointer", boxShadow: '0px 1px 2px 0px grey', padding: 10, display: 'flex', flex: 1, justifyContent: 'center', backgroundColor:this.state.foroutsider?'#6072E4':'white',color:this.state.foroutsider?'white':'black' }} >Outsiders</span>
                                                <span onClick={(event) => this.setState({fortenant: false,foroutsider: false,individual: !this.state.individual} )}  style={{ cursor:"pointer", boxShadow: '0px 1px 2px 0px grey', padding: 10, display: 'flex', flex: 1, justifyContent: 'center', borderBottomRightRadius: 10, borderTopRightRadius: 10,backgroundColor:this.state.individual?'#6072E4':'white',color:this.state.individual?'white':'black' }} >Individual</span>
                                            </div>
                                            
                                            {/* <select className="form-control-sm form-control" style={{borderColor:'#fafafa',boxShadow:'0px 2px 1px #ededed',paddingLeft:18}}  name="is_active" value={this.state.is_active} onChange={this.onChange}>
                                                <option  value="false" >InActive</option>
                                                <option  value="true" >Active</option>
                                            </select>
                                             */}

                                            <div className="text-center text-muted mb-4">
                                            </div>
                                        </form>
                                        <div className="text-center">
                                            {/* <button type="button" className="btn btn-primary mt-4" onClick={this.EditDay}>edit</button> */}
                                            {this.state.loader?<LoopCircleLoading color={'#7FFF00'}  >loading</LoopCircleLoading>:<button type="button" className="btn btn-primary mt-4" onClick={this.sendNotification}>Send</button>}
                                        </div>
                                    </div>
                                </div>

                                <br/>
                                <div className="card shadow">
                                    <div className="card-header bg-transparent">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <h2 className="mb-0" />
                                                <h2>Notifications</h2>
                                                <div className="col text-right">
                                                {this.state.prev==null?<button disabled={true} className="btn btn-sm btn-primary">Prev</button>:<button className="btn btn-sm btn-primary" onClick={this.prev}>Prev</button>}
                                                {this.state.next==null?<button disabled={true} className="btn btn-sm btn-primary">Next</button>:<button className="btn btn-sm btn-primary" onClick={this.next}>Next</button>}
                                                </div>
                                            </div>

                                        </div>
                                        <div className="table-responsive">
                                        {this.state.loading?<WaveLoading  >loading</WaveLoading>
                                        :
                                        <table className="table align-items-center table-flush">
                                            <thead className="thead-light">
                                                <tr>
                                                    {/* <th scope="col">Date</th> */}
                                                    <th scope="col">Notification</th>
                                                    {/* <th scope="col">Message</th> */}

                                                    <th scope="col">Image</th>

                                                    {/* <th scope="col">price</th> */}
                                                    {/* <th scope="col">Action</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                this.state.notificationData.map((data,index)=>
                                                    <ItemsNotification
                                                        data={data} 
                                                        key={index} 
                                                        Edit={this.edit}
                                                        Delete={this.deletePriority}
                                                    />
                                                )
                                                }
                                            
                                            </tbody>
                                        </table>
                                        }

                                            
                                        </div>
                                        {/* <div className="text-center">
                                            {this.state.loader?<LoopCircleLoading color={'#7FFF00'}  >loading</LoopCircleLoading>:<button type="button" className="btn btn-primary mt-4" onClick={this.sendNotification}>Send</button>}
                                        </div> */}
                                    </div>
                                </div>

                            </div>

                            {this.state.individual&&
                             <div className="col-xl-4">
                                <div className="card shadow">
                                    <div className="card-header bg-transparent">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                {
                                                this.state.edit?
                                                <h2><i className="fas text-red fa-window-close pr-4" onClick={this.clearEdit}></i>Edit Promocode</h2>
                                                :
                                                <a className="card-header bg-transparent"><h2>Users</h2></a>
                                                }

                                            </div>
                                        </div>
                                        <form role="form">
                                            
                                            <div className="form-group">
                                                <div className="input-group input-group-alternative mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"></span>
                                                    </div>
                                                    <input name="search" value={this.state.search} onChange={this.onChangeSearch} className="form-control " placeholder="search user" type="text" />
                                                    <button type="button" className="btn btn-sm btn-white " onClick={this.addPromocode}><i className="fa fa-search" aria-hidden="true"></i></button>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div className="input-group input-group-alternative ">
                                                        <span className="col-lg" style={{minHeight:300,maxHeight:400,overflowY:"scroll"}}>
                                                        <ul className=" list-group list-group-flush ">
                                                        {this.state.filteredData.length==0?this.state.data.map((data,index)=> {
                                                            return(
                                                                <ListItems 
                                                                users={data} 
                                                                key={index} 
                                                                addToArray={this.add}
                                                                removeFromArray={this.remove}
                                                                />
                                                            )}
                                                        )
                                                        :
                                                        this.state.filteredData.map((data,index)=> {
                                                            return(
                                                                <ListItems 
                                                                users={data} 
                                                                key={index} 
                                                                addToArray={this.add}
                                                                removeFromArray={this.remove}
                                                                individual={this.state.individual}
                                                                />
                                                            )}
                                                        )
                                                        }
                                                        </ul>
                                                        </span>
                                                    </div>
                                            </div>
                            
                                            <div className="text-center text-muted mb-4">
                                            </div>
                                        </form>
                                        <div className="text-center">
                                           
                                        </div>
                                    </div>
                                </div>
                            </div> 

                            }
                           
                            
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        );
    }
}


